
import vSelect from './vselect'
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import common from '@/tools/common'
export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
async doQuery () {
if (this.year === '') {
return
}
if (this.p_name === '') {
}

let param = { p_name: this.p_name, Unit_1: this.Unit_1, Unit_2: this.Unit_2, year: this.year }
this.$router.push({name: 'StatsDirSearchResult', params: param})
},
async getUnits (type) {
const queryPromise = await this.$http.get('/API/StatsDir/Units'
, {params: {type: type}})
return queryPromise.data
},
async getYears () {
const queryPromise = await this.$http.get('/API/StatsDir/Years')
return queryPromise.data
},
clear () {
this.year = ''
this.p_name = ''
this.Unit_1 = ''
this.Unit_2 = ''
this.currentPage = 1
this.queryResult = {Data: [], TotalPage: 0}
}
},
data () {
return {
yearList: [],
year: '',
p_name: '',
Unit_1: '',
Unit_1List: ['米'],
Unit_2: '',
Unit_2List: ['米'],
currentPage: 1
}
},
async activated () {
this.Unit_1List = (await this.getUnits(1))
this.Unit_1List.unshift('')
this.Unit_2List = (await this.getUnits(2))
this.Unit_2List.unshift('')
this.yearList = (await this.getYears()).sort().reverse()
if (this.yearList.length > 0) {
this.year = this.yearList[0]
}
},
mounted () {
common.alertOnceInnerTitle(this, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为更好体现海关统计服务社会的职能，海关总署统计分析司委托中国海关出版社提供此项免费服务。本系统的所有资源及服务均源自《中国海关统计商品目录》，仅供用户查询参考。', '提示', '3')
}
}



// WEBPACK FOOTER //
// ./src/components/StatsDir.vue